import request from '@/api/request'
import { AxiosRequestConfig } from 'axios'
import type {
  ProductFiltersRes,
  ProductListReq,
  ProductListRes,
  Res,
  ResWithMeta,
  ProductThreeCategories,
  ProductLiveListReq,
  ProductLiveListRes,
  SimilarProductRes,
  ProductsSitemapRes
} from '@/types/api'

// 以图搜图
export const postImageSearchByImageApi = (params: { image: File; keyword: string }) => {
  const formData = new FormData()
  console.log('params.image入参', params)
  // 确保image是File对象
  if (!(params.image instanceof File)) {
    console.error('传入的image不是File对象:', params.image)
    throw new Error('image必须是File对象')
  }

  formData.append('image', params.image)
  formData.append('keyword', params.keyword || '')

  return request.post<ResWithMeta<ProductListRes>>(`/data/search/product-image`, formData)
}

export const getProductListApi = (params: ProductListReq, config?: AxiosRequestConfig) => {
  return request.get<ResWithMeta<ProductListRes>>(`/data/products`, { params, ...config })
}

export const getProductFilterApi = (config?: AxiosRequestConfig) => {
  return request.get<Res<ProductFiltersRes>>(`/data/products/filters`, config)
}

// 获取商品的直播列表信息
export const getProductLiveListApi = async (id: string, params: ProductLiveListReq) => {
  return request.get<ResWithMeta<ProductLiveListRes>>(`/data/products/${id}/lives`, { params, skipCodeCheck: true })
}

// 获取商品商品分类接口
export const getProductCategoryApi = async (config?: AxiosRequestConfig) => {
  return request.get<Res<ProductThreeCategories>>(`/data/products/product-category`, config)
}

export const getSimilarProductApi = async (
  id: string,
  params: {
    per_page: string
    page: string
  }
) => {
  return request.get<ResWithMeta<SimilarProductRes>>(`/data/products/${id}/similar`, { params, skipCodeCheck: true })
}

// 获取商品商品分类接口
export const getProductSitemapApi = async (
  params: { category_id?: string; page?: string },
  config?: AxiosRequestConfig
) => {
  return request.get<Res<ProductsSitemapRes>>(`/data/products/sitemap/list`, { params, ...config })
}

// 获取销售趋势
export const getProductTrends = async (id: string) => {
  return request.get<ResWithMeta<any>>(`/data/products/trends/${id}`, { skipCodeCheck: true })
}

// 获取销售趋势列表
export const getProductTrendsListApi = async (params: { ids: string[] }) => {
  return request.get<ResWithMeta<any>>(`data/products/list/trends`, { params, skipCodeCheck: true })
}
